if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.openCart = new CustomEvent("open-cart");
        this.closeCart = new CustomEvent("close-cart");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const originalFormData = new FormData(this.form);

        // ID principal du produit
        const mainVariantId = originalFormData.get("id");
        // ID du produit de mise à taille (si présent)
        const miseATailleId = originalFormData.get("properties[_id_mise_a_taille]");

        // Pour la propriété "Mise à la taille" (ex: la taille demandée),
        // on la récupère si elle existe :
        const tailleValue = originalFormData.get("properties[Mise à la taille]");

        // Pour la propriété "Livraison"
        const livraisonValue = originalFormData.get("properties[Livraison]");

        /**
         * 2) On construit un "nouveau" FormData() multi-items
         */
        const formData = new FormData();

        // Item 0 => produit principal
        formData.append("items[0][id]", mainVariantId);
        formData.append("items[0][quantity]", 1);

        // S’il y a une property "Mise à la taille" (ex: la taille demandée),
        // on l’attache comme propriété au produit principal
        if (tailleValue) {
          formData.append("items[0][properties][Mise à la taille]", tailleValue);
        }

        // S'il y a une property "Livraison", on l'attache aussi
        if (livraisonValue) {
          formData.append("items[0][properties][Livraison]", livraisonValue);
        }

        // Item 1 => mise à taille, si l’id existe
        if (miseATailleId) {
          formData.append("items[1][id]", miseATailleId);
          formData.append("items[1][quantity]", 1);
        }

        // On ajoute aussi les sections à charger
        if (this.cart) {
          const sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.append("sections", sections);
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;

            this.cart.renderContents(response);

            console.log("open cart");
            // Ouvrir le panier avec Alpine.
            window.dispatchEvent(this.openCart);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        // Chercher d'abord par ID dans le contexte du product-form, puis par classe
        this.errorMessageWrapper = this.errorMessageWrapper ||
          this.querySelector("[id^='product-form-error-message-wrapper']") ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;

          // Faire scroller vers le message d'erreur
          setTimeout(() => {
            if (this.errorMessageWrapper && !this.errorMessageWrapper.hasAttribute("hidden")) {
              this.errorMessageWrapper.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
              });

              // Focus sur le message d'erreur pour l'accessibilité
              const errorMessageElement = this.errorMessageWrapper.querySelector(".product-form__error-message");
              if (errorMessageElement) {
                errorMessageElement.focus();
              }
            }
          }, 100);
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
